
const newModel = () => {
    return {
        diemWifiCongCongId: null,
        tenDiaDiem: null,
        congTyId: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        diemWifiCongCongId: null,
        tenDiaDiem: null,
        congTyId: null,
        tenCongTy: null,
        phuongXaId: null,
        tenPhuongXa: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        diemWifiCongCongId: item.diemWifiCongCongId,
        tenDiaDiem: item.tenDiaDiem,
        congTyId: item.congTyId,
        tenCongTy: item.tenCongTy,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        diemWifiCongCongId: item.diemWifiCongCongId,
        tenDiaDiem: item.tenDiaDiem,
        congTyId: item.congTyId,
        tenCongTy: item.tenCongTy,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        tenDiaDiem: null,
        congTyId: null,
        phuongXaId: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        tenDiaDiem: item.tenDiaDiem,
        congTyId: item.congTyId,
        phuongXaId: item.phuongXaId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        diemWifiCongCongId: null,
        tenDiaDiem: null,
        congTyId: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const diemWifiCongCongModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


